import { useEffect, useState } from 'react';

const requests = new Map();

const toItem = (product) => ({
  key: String(product.id),
  title: product.title,
  url: product.url,
  image: product.images && product.images[0],
  price: product.price,
  includeFrom: !!product.has_multiple_prices,
  ariaLabel: `View ${product.title}`,
});

const fetchSuggested = (productId) => {
  if (!requests.has(productId)) {
    requests.set(
      productId,
      Promise.resolve(
        fetch(`/product-info/${productId}/suggested`, {
          headers: { Accept: 'application/json' },
        }),
      )
        .then((response) =>
          response && response.ok ? response.json() : { products: [] },
        )
        .then((data) => (data.products || []).map(toItem))
        .catch(() => {
          requests.delete(productId);
          return [];
        }),
    );
  }

  return requests.get(productId);
};

const useSuggestedProducts = (productId) => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    setItems([]);

    if (productId) {
      fetchSuggested(productId).then((result) => {
        if (active) setItems(result);
      });
    }

    return () => {
      active = false;
    };
  }, [productId]);

  return items;
};

export default useSuggestedProducts;
